import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CustomerNotes } from "@app/models/customer-notes";
import { CustomerNoteService } from "@app/services/customer-note.service";

@Component({
    selector: "app-select-customer-note-popup",
    templateUrl: "./select-customer-note-popup.component.html",
    styleUrls: ["./select-customer-note-popup.component.css"],
    standalone: false
})
export class SelectCustomerNotePopupComponent implements OnInit {
  @Input() customerNotes: Array<CustomerNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedCustomerNotes: Array<CustomerNotes>;
  @Output() onSubmit = new EventEmitter<Array<CustomerNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private customerNoteService: CustomerNoteService) {}

  ngOnInit() {
    if (!this.selectedCustomerNotes) {
      this.selectedCustomerNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(customerNote) {
    if (customerNote) {
      const parentIds = this.customerNoteService.findCustomerNoteParents(customerNote, this.customerNotes);
      this.selectedCustomerNotes = [
        ...this.selectedCustomerNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedCustomerNotes.push(customerNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedCustomerNotes);
  }

  deleteSelectedCustomerNote(customerNote) {
    if (customerNote) {
      var children = this.findAllChidren(customerNote);
      this.selectedCustomerNotes = this.selectedCustomerNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (customerNote.parentCustomerNoteId) {
        var parent = this.customerNoteService.findCustomerNoteById(customerNote.parentCustomerNoteId, this.customerNotes);
        this.selectedCustomerNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: CustomerNotes[], customerNote: CustomerNotes) {
    const set1 = new Set(checkArray);
    const parents = this.customerNoteService.findCustomerNoteParents(customerNote, this.customerNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(customerNote: CustomerNotes) {
    var items = [];
    if (customerNote) {
      items.push(customerNote);
      if (customerNote.subCustomerNotes && customerNote.subCustomerNotes.length > 0) {
        customerNote.subCustomerNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
